<template lang="pug">
  div(class="filters")
    v-row
      v-col(
        v-for="(item, idx) in items"
        :key="idx"
        :cols="item.cols"
      )
        component(
          :value="item.initialValue"
          :is="item.component"
          v-bind="item.componentProps"
          @input="onInput(item, $event)"
        )
</template>

<script>
import { VSelect, VTextField, VTextarea } from 'vuetify/lib'
import EInputDebounce from '~/components/elements/inputs/e-input-debounce'
import EInputDatetimeRange from '~/components/elements/inputs/e-input-datetime-range'

export default {
  name: 'MTableFilters',
  components: {
    VSelect,
    VTextarea,
    VTextField,
    EInputDebounce,
    EInputDatetimeRange
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    onInput(item, value) {
      this.$emit(`update:${item.model}`, value)
    }
  }
}
</script>

<style scoped lang="scss"></style>
